import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from '../../../../classes/api-response';
import { UsersService } from '../../../../services/users.service';
import { SnackService } from '../../../../services/snack.service';
import { Customer } from "../../../../model/customer";
import { CompaniesService } from "../../../../services/companies.service";
import { Company } from "../../../../model/company";
import { Constants } from "../../../../utils/constants";
import { AuthService } from "../../../../services/auth.service";
import { Tester } from 'src/app/model/tester';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'aw-tester-form',
  templateUrl: './tester-form.component.html',
  styleUrls: ['./tester-form.component.scss']
})
export class TesterFormComponent implements OnInit {

  userForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingCompanies = false;
  saving = false;
  isEditing = false;
  generalError?: ApiResponse;

  companies: Company[] = [];
  loggedUser: any;
  selectedCompany: Company | undefined = new Company();
  roles = Constants.roles;

  previousUrl: string;

  constructor(
    private userService: UsersService,
    private authService: AuthService,
    private snackService: SnackService,
    private companiesService: CompaniesService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (route.snapshot.url[0])
      this.previousUrl = route.snapshot.url[0].path;
    this.userForm = new UntypedFormGroup(
      {
        email: new UntypedFormControl(
          '',
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"),
            Validators.required
          ]
        ),
        firstName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')

          ]
        ),
        lastName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
            Validators.pattern('[- +()0-9]+'),
            Validators.required
          ]
        ),
        company: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      },
    );


  }

  _tester = new Tester();

  @Input() set tester(value: Tester) {
    this._tester = merge(new Tester(), value);
    this.selectedCompany = value?.company;
    this.isEditing = !!value?.id;
    this.userForm.patchValue(this._tester);
    if (value.id) {
      this.userForm.controls.email.disable();
    }
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();

    this.loadingCompanies = true;

    if (!this.isEditing && this.loggedUser.role !== this.roles.customer) {
      this.companiesService.getAllCompanies().subscribe(companies => {
        this.companies = companies;
        this.loadingCompanies = false;
      });
    }
    else if (!this.isEditing && this.loggedUser.role === this.roles.customer) {
      this._tester.company = this.loggedUser.company;
      this.userForm.patchValue(this._tester);
    }
  }

  saveUser(): void {

    this.saving = true;

    const newUser = merge(new Tester(), this._tester, this.userForm.value);

    this.generalError = undefined;

    if (this._tester.id) {
      // delete newUser.company;
      this.userService.updateTester(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.tester = newUser;
            this.snackService.success('Tester updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {
      this.userService.createTester(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.tester = newUser;
            this.snackService.success('Tester created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

  onCancel():void {

    if(this.previousUrl === 'edit')
      this.router.navigateByUrl("/reserved/profile")
    this.tester = this._tester;
    this.canceled.emit();

  }




}

